// extracted by mini-css-extract-plugin
export default {"item-list":"CocktailsDesktop_item-list__sUclc","item":"CocktailsDesktop_item__QntwV","section":"CocktailsDesktop_section__JhPud"};